// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"LocaleSelect_dropdown_2avTN","label":"LocaleSelect_label_1KCrl","icon":"LocaleSelect_icon_2og5a","list":"LocaleSelect_list_36xy0"};